<template>
  <div class="mit-volumes-list pa-5">
    <BaseMitLoading :show="loading" :fullscreen="false"/>
    <v-card flat>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <template v-slot:activator="{ on }">
          <v-btn small v-on="on" class="ma-2" @click="resetDialog">Add Filter</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Add Filter</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-select :items="filterableHeaders" :hint="filterItem.hint" :persistent-hint="true" item-text="text" item-value="value" label="Name" required v-model="filterItem" return-object @change="changedFilter"></v-select>
                  <v-text-field label="Value" required v-model="filterValue"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
            <v-btn color="blue darken-1" text @click="addFilter">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        <BaseMitUrlParams ref="mitUrlParamsRef" v-on:changed="updateFilters"/>
    </v-card>
    <BaseMitDataTable
      title="Volumes"
      :page="paging.page"
      :pageSize="paging.pageSize"
      :totalItems="paging.totalItems"
      :pageSizes="{itemsPerPageOptions:[10, 20, 50, 100]}"
      :editable="false"
      :headers="headers"
      :items="volumes"
      @pagination="updatePagination"
      @click:row="showVolumeDetails"
      @update:sort-by="sortByChanged"
      @update:sort-desc="sortDirectionChanged"
    >
      <template v-slot:item.data_ui="{ item, search }">
        <v-tooltip top max-width="600" color="#333" offset-overflow style="opacity: 1!important;">
          <template v-slot:activator="{ on }">
            <v-icon :color="(search.text.length > 0 && item.data_ui.indexOf(search.text) > -1 )?'primary':''" :class="" v-on="on">mdi-text-box-outline</v-icon>
          </template>
          <div style="word-break: break-word;"> {{item.data}}</div>
        </v-tooltip>
      </template>
    </BaseMitDataTable>
  </div>
</template>

<script>
import moment from 'moment';
import MitUnitsService from '../services/MitUnitsService.js';
let currentUnit = MitUnitsService.getUserVolumeUnit();
import MitStorageService from '../services/MitStorageService.js';
import BaseMitDataTable from '../../base/components/BaseMitDataTable.vue';
import BaseMitUrlParams from '../../base/components/BaseMitUrlParams.vue';
import BaseMitLoading from '../../base/components/BaseMitLoading.vue';

export default {
  name: 'MitVolumesList',
  components: {
    BaseMitLoading,
    BaseMitDataTable,
    BaseMitUrlParams
  },
  props: {
  },
  data: function() {
    return {
      dialog:false,
      filterItem:null,
      filterValue:'',
      loading:false,
      search: '',
      options:{},
      paging:{
        page:1,
        pageSize:5,
        totalItems:0
      },
      filterableHeaders:[ //moment().local().format("hh:mm A")
        {text: 'Mount Point',value: 'mountPoint', default:'', hint:'The exact Mount Point address'},
        {text: 'Host',value: 'host', default:'', hint:'The host of the volume'},
        {text: 'Owner',value: 'owner', default:'', hint:'The owner associated with this volume'},
        {text: 'PI',value: 'pi', default:'', hint:'The PI associated with this volume'},
        // {text: 'Create Date',value: 'createDt', default:MitStorageService.getDateNowStringLocal(), hint:'Create Date >=. Format is "YYYY-MM-DD HH:mm:ss" 24h local time.'},
      ],
      headers:[
          {text: 'Mount Point',sortable: true,value: 'mountPoint'},
          {text: 'Host',sortable: true,value: 'host'},
          {text: 'Owner',sortable: true,value: 'owner'},
          {text: 'PI',sortable: true,value: 'pi'},
          // {text: 'External Id',sortable: true,value: 'externalId'},
          {text: 'Size Available ('+currentUnit.unit+')',sortable: true, value: 'sizeConverted.available'},
          {text: 'Size Used ('+currentUnit.unit+')',sortable: true,value: 'sizeConverted.used'},
          {text: 'Size Total ('+currentUnit.unit+')',sortable: true,value: 'sizeConverted.total'},
          {text: 'Used By Snapshots ('+currentUnit.unit+')',sortable: false, value: 'sizeConverted.usedBySnapshots'},
          {text: 'Compression Ratio',sortable: false, value: 'compressRatio'}
          // {text: 'Last Updated',sortable: false,value: 'dates_local.lastEditedDt'},
          // {text: 'Edit Date',sortable: true,value: 'dates_local.lastEditedDt'}
        ],
      volumes:[]
    }
  },
  created() {
    this.resetDialog();
    this.refreshData(this.paging, this.options);

  },
  methods : {
    showVolumeDetails (volumeData){
        this.$router.push('/storage/'+volumeData.id);
    },
    updatePagination (pagination) {
      //setting this into the control will trigger this event so initially don't bother refreshing
      //if the items length is zero, we have no data yet.
      if(pagination.itemsLength > 0){
        this.paging.page = pagination.page;
        this.paging.pageSize = pagination.itemsPerPage;

        this.refreshData(this.paging, this.options);
      }

    },
    sortByChanged(prop){
        this.paging.page = 1;//we changed the filter so start over with a new data set
        if(prop){
            console.log('sortByChanged: ',prop);
            switch(prop){
                case 'sizeConverted.available':
                    this.options.orderBy = 'size_available-ASC';
                    break;
                case 'sizeConverted.used':
                    this.options.orderBy = 'size_used-ASC';
                    break
                case 'sizeConverted.total':
                    this.options.orderBy = 'size_total-ASC';
                    break;
                case 'mountPoint':
                    this.options.orderBy = 'mount_point-ASC';
                    break;
                default:
                    this.options.orderBy = prop+'-ASC';
            }

            this.refreshData(this.paging, this.options);
        }
        else{
            delete this.options.orderBy;
            this.refreshData(this.paging, this.options);
        }

    },
    sortDirectionChanged(desc){
        if(desc){
            this.paging.page = 1;//we changed the filter so start over with a new data set
            this.options.orderBy = this.options.orderBy.split('-')[0]+'-DESC';
            this.refreshData(this.paging, this.options);
        }

    },
    updateFilters(options){
        this.options = options;

        if(this.paging.totalItems > 0){

          //Don't blindly do this as it will trigger the pagination event.
          if(this.paging.page != 1)
            this.paging.page = 1;//we changed the filter so start over with a new data set

          this.refreshData(this.paging, this.options);
        }
    },
    refreshData(pagination, options){
      this.loading = true;
      MitStorageService.requestGetVolumes(pagination, options)
        .then((data) => {

          this.volumes = data.volumes;
          this.paging.totalItems = data.total;

          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log('An error occurred trying to get keys list', error);
        });
    },
    resetDialog(){
      this.filterItem = this.filterableHeaders[0];
      this.filterValue = null;
    },
    changedFilter(item){
      this.filterValue = item.default;
    },
    addFilter(){
      if(MitStorageService.isDateTimeValid(this.filterValue)){
        this.filterValue = MitStorageService.getDateStringUtc(this.filterValue);
      }

      this.$refs.mitUrlParamsRef.add(this.filterItem.value, this.filterValue);
      this.dialog = false;
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
